<template>
  <v-card :class="$vuetify.breakpoint.mdAndUp ? 'card-shadow card-padding' : 'card-shadow'">
    <v-card-title
      class="
        pt-0
        px-3
        card-padding
        text-h4 text-typo
        justify-space-between
        border-bottom
      "
    >
      <h2>Nuovo Utente</h2>
      <v-spacer></v-spacer>
      <v-btn small icon @click="$emit('chiudiDialogNew')">
        <v-icon size="20" class="text-typo">fas fa-times</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text class="pb-0 d-flex flex-column px-0">
      <v-form
        @submit="submit"
        v-model="formValid"
        ref="form_data"
        autocomplete="off"
        lazy-validation
      >
        <v-card>
          <v-card-text class="pa-6 pt-3 text-center font-size-root">
            <label
              class="label-color font-weight-600 d-block text-left text-h5 mt-2"
              >Nome</label
            >
            <v-text-field
              hide-details="auto"
              required
              :rules="nomeRules"
              outlined
              background-color="rgba(255,255,255,.9)"
              light
              placeholder="Nome"
              autocomplete="off"
              v-model="nome"
              class="
                font-size-input
                placeholder-lighter
                text-color-light
                input-alternative input-focused-alternative input-icon
                mb-4
              "
            ></v-text-field>

            <label
              class="label-color font-weight-600 d-block text-left text-h5 mt-2"
              >Matricola</label
            >
            <v-text-field
              hide-details="auto"
              required
              :rules="matricolaRules"
              outlined
              background-color="rgba(255,255,255,.9)"
              light
              placeholder="Matricola"
              autocomplete="off"
              v-model="matricola"
              class="
                font-size-input
                placeholder-lighter
                text-color-light
                input-alternative input-focused-alternative input-icon
                mb-4
              "
            ></v-text-field>

            <label
              class="label-color font-weight-600 d-block text-left text-h5 mt-2"
              >Password</label
            >
            <v-text-field
              hide-details="auto"
              outlined
              background-color="rgba(255,255,255,.9)"
              light
              placeholder="Password"
              autocomplete="off"
              type="password"
              v-model="password"
              class="
                font-size-input
                placeholder-lighter
                text-color-light
                input-alternative input-focused-alternative input-icon
                mb-6
              "
            ></v-text-field>

            <v-checkbox
              v-model="consentiLogin"
              color="primary"
              :ripple="false"
              class="ma-0 checkbox-custom checkbox-thinner"
              hide-details
            >
              <template v-slot:label>
                <span class="text-muted text-body-2 ls-0">Consenti Login</span>
              </template>
            </v-checkbox>

            <label
              class="label-color font-weight-600 d-block text-left text-h5 mt-2"
              >Ruolo</label
            >
            <v-select
              hide-details="auto"
              required
              :rules="requiredRules"
              :items="['Amministratore', 'Operatore']"
              class="
                input-style
                font-size-input
                text-light-input
                placeholder-light
                select-style
              "
              v-model="ruolo"
              outlined
              placeholder="Ruolo"
              single-line
            ></v-select>

            <label
              class="label-color font-weight-600 d-block text-left text-h5 mt-4"
              >Email</label
            >
            <v-text-field
              hide-details="auto"
              outlined
              :rules="emailRules"
              background-color="rgba(255,255,255,.9)"
              light
              placeholder="Email"
              type="email"
              autocomplete="off"
              v-model="email"
              class="
                font-size-input
                placeholder-lighter
                text-color-light
                input-alternative input-focused-alternative input-icon
                mb-4
              "
            ></v-text-field>

            <label
              class="label-color font-weight-600 d-block text-left text-h5 mt-2"
              >Note</label
            >
            <v-textarea
              hide-details="auto"
              outlined
              auto-grow
              rows="2"
              background-color="rgba(255,255,255,.9)"
              light
              placeholder="Note"
              autocomplete="off"
              v-model="note"
              class="
                font-size-input
                placeholder-lighter
                text-color-light
                input-alternative input-focused-alternative input-icon
                mb-4
              "
            ></v-textarea>

            <v-btn
              elevation="0"
              :ripple="false"
              height="43"
              class="
                font-weight-600
                text-capitalize
                btn-primary
                py-3
                px-6
                rounded-sm
                my-1
              "
              color="primary"
              type="submit"
              >Crea</v-btn
            >
          </v-card-text>
        </v-card>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import apiUtenti from "@/js/pages/utenti";
import {
  emailValidaRules,
  nomeRules,
  requiredRules,
  matricolaRules,
} from "@/js/validationRules";

export default {
  name: "newUtente",
  data() {
    return {
      token: this.$cookies.get("token_goldencar"),
      this_ruolo: this.$store.state.ruolo,
      email: "",
      nome: "",
      matricola: "",
      password: "",
      note: "",
      ruolo: "",
      formValid: false,
      emailRules: emailValidaRules,
      nomeRules: nomeRules,
      matricolaRules: [...matricolaRules],
      requiredRules: requiredRules,
      listMatricole: [],
      loading: false,
      consentiLogin: false,
    };
  },
  async created() {
    this.listMatricole = await apiUtenti.getAllMatricole(this.token) || [];
    this.matricolaRules = [
      v => !!v || 'Matricola richiesta',
      v => /^[0-9]{3,6}$/.test(String(v).toLowerCase()) || 'Matricola non valida',
      v => !this.listMatricole.includes(parseInt(v)) || 'Matricola già inserita'
    ];
  },
  methods: {
    async submit(e) {
      e.preventDefault();
      if(!this.loading) {
        this.loading = true;
        if (this.$refs.form_data.validate() && this.formValid) {
          let data = {
            nome: this.nome,
            matricola: this.matricola,
            email: this.email,
            ruolo: this.ruolo,
            note: this.note,
            password: this.password,
            consentiLogin: this.consentiLogin,
          };
          let newUtente = await apiUtenti.insertNew(this.token, data);
          if (newUtente === "matricolaEsistente")
            alert("Matricola già inserita!");
          else if (newUtente) this.$emit("chiudiDialogNew");
          else alert("Errori durante la creazione, ricontrolla i dati");
        }
        this.loading = false;
      }
    },
  },
};
</script>
